<div fxFlex="100" class="companyD" fxLayout="row wrap">
    <!-- Company Name -->
    <app-text-field [isEditable]="true" [label]="'Company Name*'" [(ngModel)]="companyObj.name" [name]="'name'"
        [minlength]="3" [errors]="companyObj.error.name" fxFlex="12em">
    </app-text-field>

    <!-- Country -->
    <app-mat-auto-search [isEditable]="true" [label]="'Country*'" [name]="'country'" [ngModel]="companyObj.country"
        [idField]="null" [displayField]="'name'" (ngModelChange)="filterStateByCountryId($event)"
        [listUrl]="country_url" [errors]="companyObj.error.country" fxFlex="12em">
    </app-mat-auto-search>

    <!-- <logzy-country-field [isEditable]="true" [label]="'Country*'" [name]="'country'" [ngModel]="companyObj.country"
        [idField]="null" [displayField]="'name'" (ngModelChange)="filterStateByCountryId($event)"
        [listUrl]="country_url" [errors]="companyObj.error.country" fxFlex="12em"></logzy-country-field> -->

    <!-- State -->
    <app-mat-auto-search [isEditable]="true" [label]="'State*'" [(ngModel)]="companyObj.state"
        (ngModelChange)="bindAddress($event)" [name]="'state'" [idField]="null" [displayField]="'name'"
        [listUrl]="state_url" [errors]="companyObj.error.state" fxFlex="12em">
    </app-mat-auto-search>

    <!-- Address -->
    <app-text-field [isEditable]="true" [label]="'Main Branch Address*'" [(ngModel)]="companyObj.address"
        [name]="'address'" [isMultiline]="true" [minlength]="5" [errors]="companyObj.error.address" fxFlex="12em">
    </app-text-field>

    <!-- Is B2C -->
    <mat-checkbox fxFlex="26em" color="primary" [(ngModel)]="companyObj.is_b2c" style="margin-bottom: 1em;" [name]="'is_b2c'">
        Is B2C?
    </mat-checkbox>
</div>

<div class="btnb">
    <button mat-stroked-button class="Save" (click)="onCompanySave()">Save</button>
</div>
